import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledMain = styled.main`
  background-color: ${themeStyles.colors.white.main};
`
